import { render, staticRenderFns } from "./pvTrend.vue?vue&type=template&id=58c89cee&"
import script from "./pvTrend.vue?vue&type=script&lang=js&"
export * from "./pvTrend.vue?vue&type=script&lang=js&"
import style0 from "./pvTrend.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports